import { Controller } from "@hotwired/stimulus"
import { FetchRequest, get } from '@rails/request.js'
export default class extends Controller {
  showLoadingDotsOnRegFormSubmit(e) {
    if (e.target.getAttribute("data-turbo-frame") == 'overlays' || e.target.classList.contains('reg_modal') || e.target.classList.contains('close-modal-links')) {
      const triggerLoadElement = document.querySelector('.continue');
      const loadingElement = document.querySelector('.form-submit-loading');
      triggerLoadElement.style.display = 'none';
      loadingElement.style.display = 'block';
    }
  }

  async showFeaturedJobsModal(e, hideModalOnLoad = false) {
    // Hide the modal and replace with loading dots if hideModalOnLoad is true
    if (hideModalOnLoad) {
      const modal = document.querySelector('.modal');
      const loadingElement = document.querySelector('.featured-jobs-loading');
      modal.style.display = 'none';
      loadingElement.style.display = 'block';
    } else {
      this.showLoadingDotsOnRegFormSubmit(e);
    }

    // Show loading dots while turbo_load_overlays is fetching the featured jobs
    try {
      await get('/turbo_load_overlays?overlay=featured_job&job_count=3&update_turbo_frame=true');
    } catch (error) {
      console.error('Error calling /turbo_load_overlays: ', error);
    }

    //  Once we get featured jobs returned, show the modal again and hide featured jobs loading dots
    if (hideModalOnLoad) {
      const modal = document.querySelector('.modal');
      const loadingElement = document.querySelector('.featured-jobs-loading');
      modal.style.display = 'block';
      loadingElement.style.display = 'none';
    }
  }

  fakeCloseModalAndShowFeaturedJobs(e) {
    // Only show the featured jobs when click is outside reg modal (instead of anywhere in the window)
    if ((this.element.classList.contains('modal-static') || e.target.classList.contains('modalBtnClose') || e.target.classList.contains('close-modal-links')) && !e.target.querySelector('.featured-job-details')) {
      this.showFeaturedJobsModal(e, true);
    }
  }
}
